import { withInstall } from '@tav-ui/utils/with-install'
import FileCards from './index.vue'

export * from './types'
export const TaFileCards = withInstall(FileCards)
export default TaFileCards
